import { api } from "./api";

/** Persistent client-side session id for anonymous funnel tracking. */
function sessionId() {
  try {
    let s = localStorage.getItem("dsl_sid");
    if (!s) {
      s = "sid_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("dsl_sid", s);
    }
    return s;
  } catch { return "sid_anon"; }
}

/** Fire-and-forget analytics event. Never throws.
 *  Dual-writes to (1) our internal /analytics/track backend and
 *  (2) window.dataLayer so GTM/GA4 Custom Event triggers can consume it.
 */
export function track(name, props = {}) {
  const { live_id, product_id, ...rest } = props || {};
  // (1) Internal backend log — powers /admin/analytics
  api.post("/analytics/track", {
    name,
    session_id: sessionId(),
    live_id: live_id || null,
    product_id: product_id || null,
    props: rest,
  }).catch(() => { /* swallow */ });
  // (2) GTM/GA4 forward — flat top-level params for easier variable pickup
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: name,
        dsl_session_id: sessionId(),
        dsl_live_id: live_id || null,
        dsl_product_id: product_id || null,
        ...rest,
      });
    }
  } catch { /* swallow */ }
}
